const Header = ({dataEmpresa = {logoPeque:''}, dataUser = {}}) => {
    return (
        <div className="header">
            <div className="empresa">
                {dataEmpresa.logoPeque ? (
                    <img src={dataEmpresa.logoPeque} alt="logo" />
                ) : (
                    <div className="loading-placeholder">Loading logo...</div>
                )}
                <h1>{dataEmpresa.title || 'Empresa'}</h1>
                <h1>Administración</h1>
            </div>
            <div className="user">
                {dataUser.photoURL ? (
                    <img className="user-avatar" src={dataUser.photoURL} alt="user" />
                ) : (
                    <div className="loading-placeholder">Loading user avatar...</div>
                )}
                <span>{dataUser.displayName || 'Usuario'}</span>
            </div>
        </div>
    );
};
export default Header;
